export var SetLikeEnableVer5Report;
(function (SetLikeEnableVer5Report) {
    // 非会员用户
    SetLikeEnableVer5Report["NO_VIP_USER"] = "novip_user";
    // 普会用户
    SetLikeEnableVer5Report["VIP_USER"] = "vip_user";
    // 超会用户
    SetLikeEnableVer5Report["SUPER_VIP_USER"] = "svip_user";
    // 超会plus用户
    SetLikeEnableVer5Report["SUPER_VIP_PLUS_USER"] = "svip_plus";
})(SetLikeEnableVer5Report || (SetLikeEnableVer5Report = {}));
export var SetLikeEnableReport;
(function (SetLikeEnableReport) {
    SetLikeEnableReport["OPERATION_NAME"] = "doc_vip_like";
    SetLikeEnableReport["MODULE"] = "switch";
})(SetLikeEnableReport || (SetLikeEnableReport = {}));
export var SetLikeEnableActionReport;
(function (SetLikeEnableActionReport) {
    SetLikeEnableActionReport["ON"] = "on";
    SetLikeEnableActionReport["OFF"] = "off";
})(SetLikeEnableActionReport || (SetLikeEnableActionReport = {}));
// 上传 position 触发来源位置
export var SetLikeEnableTitleBarReport;
(function (SetLikeEnableTitleBarReport) {
    SetLikeEnableTitleBarReport["PC_TITLEBAR"] = "pc_titlebar";
    SetLikeEnableTitleBarReport["MOBILE_TITLEBAR"] = "mobile_titlebar";
})(SetLikeEnableTitleBarReport || (SetLikeEnableTitleBarReport = {}));
export var SetLikeEnableEventCodeReport;
(function (SetLikeEnableEventCodeReport) {
    SetLikeEnableEventCodeReport["DOC_VIP_LIKE_SWITCH_ON"] = "doc_vip_like-switch-on";
    SetLikeEnableEventCodeReport["DOC_VIP_LIKE_SWITCH_OFF"] = "doc_vip_like-switch-off";
})(SetLikeEnableEventCodeReport || (SetLikeEnableEventCodeReport = {}));
// 超级会员或者普通会员是否已启用
export var SetLikeEnableVipStatusReport;
(function (SetLikeEnableVipStatusReport) {
    SetLikeEnableVipStatusReport[SetLikeEnableVipStatusReport["VIP_OFF"] = 1] = "VIP_OFF";
    SetLikeEnableVipStatusReport[SetLikeEnableVipStatusReport["VIP_ON"] = 2] = "VIP_ON";
})(SetLikeEnableVipStatusReport || (SetLikeEnableVipStatusReport = {}));
